export default __webpack_public_path__ + "static/media/noReviews.3004b85d.png";